import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import CadastrarInsumoRecord from '@components/InsumoRecord/CadastrarInsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';
import { withRouter } from 'react-router-dom';

/**
 * Tela para cadastro de Fertilizantes Organicos
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function EditarFertilizantesOrganicos(props) {
  useEffect(() => {
    const title = 'fertilizantesOrganicos.cadastroDeFertilizantesOrganicos';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <CadastrarInsumoRecord
      id={props.match.params.id}
      insumoURL={'fertilizantes-organicos'}
      insumoEnum={Insumo.FERTILIZANTE_ORGANICO}
      infoUsuario={props.infoUsuario}
      saveMessage={formatMessage(
        'fertilizantesOrganicos.' +
          (props.match.params.id
            ? 'fertilizantesOrganicosEditadoComSucesso'
            : 'fertilizantesOrganicosCadastradoComSucesso')
      )}
      falhaSaveMesssage={formatMessage(
        'fertilizantesOrganicos.' +
          (props.match.params.id
            ? 'falhaAoEditarFertilizantesOrganicos'
            : 'falhaAoCadastrarFertilizantesOrganicos')
      )}
      falhaCarregarMensagem={formatMessage('fertilizantesOrganicos.falhaAoCarregarFertilizantesOrganicos')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info
});

export default withRouter(connect(mapStateToProps)(EditarFertilizantesOrganicos));
